module.exports = __webpack_public_path__ + "media/images/version_merge/target_compass-657a88a41cb831424e88cbd60aeb3cc5.jpg";